<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button class="text-primary" (click)="dismiss()">
				<ion-icon slot="icon-only" name="chevron-back" />
			</ion-button>
		</ion-buttons>

		<ion-title class="text-primary fbold f24 pl-0" *transloco="let t;">{{ t('title.avail_region') }}</ion-title>
	</ion-toolbar>
</ion-header>

<div class="d-flex flex-column px-4 pt-4" *transloco="let t;">
	<div class="pb-2 border-bottom">
		<div class="title-case-1 text-white">{{ t('subtitle.language') }}</div>
		<ups-pill-button class="mt-3" [btns]="lang" [fixWidth]="true" (onChange)="selectLanguage($event);" [defaultIdx]="activeLang" />
	</div>

	<div class="title-case-1 text-white py-3">{{ t('subtitle.select_location') }}</div>

	<div class="country-container">
		@for (r of countryService.regionCountry; track r) {
			<div class="text-white title-case-3 mt-3">{{ r.name }}</div>
	
            <div class="mt-2 pt-1 mb-5 d-flex flex-wrap">
                @for (c of r.countries; track c) {
                    <div class="rb-sizer pr-2 mb-2">
                        <a title="{{ c.name }}" class="btn w-100 d-flex align-items-center" [class.bg-primary]="c.code === activeCountry.code" (click)="selectCountry(c);">
                            <span class="fflag-up ff-lg mr-3 flex-shrink-0 fflag-{{ c.code }}"></span>
                            <div class="label fthin text-left text-truncate">{{ c.name }}</div>
                        </a>
                    </div>
                }
            </div>
		}
	</div>
</div>
